import { apiFetch } from '../utils/apiFetch';
import { API_CONFIG, QUESTIONNAIRE_TYPE } from '../constants';
import { mapQuestionnaireResponseToCategory } from '../utils/helpers';
import { QuestionnaireResponse } from '../dtos/questionnaire';

export type QuestionnaireType = typeof QUESTIONNAIRE_TYPE[keyof typeof QUESTIONNAIRE_TYPE];

export const fetchQuestionnaire = async (type: QuestionnaireType): Promise<QuestionnaireResponse> => {
    try {
        const response = await apiFetch({
            url: API_CONFIG.ENDPOINTS.QUESTIONNAIRE,
            method: 'GET',
            params: { type },
        });

        return await response.json();
    } catch (error) {
        console.error('Error fetching questionnaire:', error);
        throw error;
    }
};

export const fetchAllCategories = async () => {
    const [wellness, lifestyle, healthAssessment] = await Promise.all([
        fetchQuestionnaire(QUESTIONNAIRE_TYPE.WELLNESS),
        fetchQuestionnaire(QUESTIONNAIRE_TYPE.LIFESTYLE),
        fetchQuestionnaire(QUESTIONNAIRE_TYPE.HEALTH_ASSESSMENT),
    ]);

    return [
        mapQuestionnaireResponseToCategory(wellness, QUESTIONNAIRE_TYPE.WELLNESS),
        mapQuestionnaireResponseToCategory(lifestyle, QUESTIONNAIRE_TYPE.LIFESTYLE),
        mapQuestionnaireResponseToCategory(healthAssessment, QUESTIONNAIRE_TYPE.HEALTH_ASSESSMENT),
    ].filter(Boolean);
};
